import { createGlobalStyle } from 'styled-components';

import CenturyGothicBold from '@/assets/fonts/centurygothic_bold.ttf';
import Background from '@/assets/icons/cover-images/full-panda.png';

const VariationsStyles = createGlobalStyle`
 @font-face {
     font-family: 'CenturyGothicBold';
     src: url(${CenturyGothicBold});
   }   
  
  .generated-images-holder-var27 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1200px;
  }
  .image-holder-var27 {
    width: 100%;
    display: flex;
    position: relative;
    height: 630px;
    justify-content: flex-end;
  }
  .text-var27 {
    height: 153px;
    position: absolute;
    width: calc(100% - 168px);
    margin-left: auto;
    bottom: 39px;
    font-size: 45px;
    line-height: 1.2;
    text-align: center;
    color: #000;
    font-weight: 700;
    font-family: CenturyGothicBold;
    letter-spacing: -0.05px;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      display: inline-block;
      margin: 0;
    }
    p.custom-brakes {
      white-space: nowrap;
    }
  }
  .full-image-var27 {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: relative;
    display: block;
    background: url(${Background}) no-repeat center center;
  }
  
  .actual-photo-var27 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 72px;
  }
  .actual-photo-var27--top {
    top: 0;
    bottom: auto;
  }
`;

export default VariationsStyles;
